import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { failureMessage } from '../Notifications/notificationsSlice';
import { primaryApi } from '../../utilities/apiEndpointUtility';

import { getUsers, getUsersCompleted, getUsersFailed } from './usersSlice';

export const getUsersEpic = (action$) =>
	action$.pipe(
		ofType(getUsers.type),
		mergeMap(async () => {
			try {
				const users = await axios.get(`${primaryApi()}/api/v1/users`);

				return users.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => [getUsersCompleted(res)]),
		catchError((error, source) =>
			merge(
				of(getUsersFailed(error.message), failureMessage(error.message)),
				source
			)
		)
	);

export default [getUsersEpic];
